import * as React from 'react'

const ClearIcon = props => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4378 8.49039C12.4378 10.9649 10.4278 12.9749 7.95328 12.9749C5.47878 12.9749 3.46875 10.9649 3.46875 8.49039C3.46875 7.95385 3.56485 7.44133 3.73302 6.96085C4.35765 5.2311 6.01532 4.00586 7.95328 4.00586C8.57792 4.00586 9.17852 4.13399 9.72307 4.36622C11.3167 5.05492 12.4378 6.64052 12.4378 8.49039Z"
      fill="#FFC34A"
    />
    <path
      opacity="0.6"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.49723 7.20089C8.11285 7.16085 7.72846 7.08077 7.34407 7.09679C6.71143 7.12081 6.31103 7.44914 6.01473 7.98569C5.75847 8.45016 5.55826 9.01873 5.02172 9.21893C4.78949 9.30702 4.5012 9.283 4.31701 9.11483C4.22091 9.01873 4.15685 8.8906 4.10079 8.77048C4.10079 8.76247 4.09278 8.76247 4.09278 8.75446C3.60429 7.56927 3.89258 6.19988 4.8055 5.30297C5.61432 4.50217 6.72745 4.01367 7.95268 4.01367C8.29703 4.01367 8.62536 4.05371 8.94569 4.12578C9.65841 4.28595 10.219 4.84651 10.3311 5.56724C10.3391 5.59927 10.3391 5.6233 10.3391 5.65533C10.4512 6.75244 9.48223 7.305 8.49723 7.20089Z"
      fill="#FFE332"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.57474 5.79102C5.50267 5.79102 5.4306 5.79102 5.36653 5.81504C4.99816 5.91114 4.69385 6.20744 4.57373 6.5678C4.50166 6.80004 4.50967 7.09634 4.78194 7.19243C4.838 7.20845 4.89405 7.21646 4.9421 7.21646C5.15031 7.20044 5.31848 7.08032 5.47865 6.9602L6.00718 6.55979C6.07925 6.50374 6.14332 6.43166 6.17535 6.34357C6.25543 6.13536 6.14332 5.99122 5.99116 5.90313C5.89507 5.84707 5.79096 5.82305 5.68686 5.81504L5.57474 5.79102Z"
      fill="white"
    />
    <path
      opacity="0.15"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.70323 10.8205C5.6712 10.9967 5.68722 11.1808 5.75929 11.341C6.18372 12.31 7.76131 12.8065 8.50606 11.9416C8.81838 11.5812 8.86643 11.0447 8.57814 10.6603C8.45802 10.4921 8.27383 10.38 8.08164 10.2999C7.48103 10.0197 6.47201 9.77942 5.95148 10.316C5.83136 10.4601 5.74327 10.6363 5.70323 10.8205Z"
      fill="white"
    />
    <path
      opacity="0.15"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.76707 11.4705C6.72703 11.5826 6.75105 11.7187 6.83113 11.8228C6.91121 11.9269 7.03934 11.999 7.17548 12.0471C7.31162 12.0871 7.47178 12.1031 7.5919 12.015C7.80812 11.8469 7.73605 11.4545 7.50381 11.3343C7.42373 11.2943 7.33564 11.2783 7.24755 11.2623C7.04735 11.2382 6.83113 11.2543 6.76707 11.4705Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.96758 8.49082C7.96758 8.49883 7.95957 8.50684 7.95156 8.50684C7.94355 8.50684 7.93555 8.49883 7.93555 8.49082V8.48281C7.93555 8.47481 7.94355 8.4668 7.95156 8.4668H7.95957C7.96758 8.48281 7.96758 8.49082 7.96758 8.49082Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.95157 3.25342C7.6793 3.25342 7.46308 3.04521 7.43906 2.78094L7.26288 0.842981C7.24686 0.642779 7.39901 0.474609 7.59922 0.474609H8.30393C8.50413 0.474609 8.65629 0.642779 8.64027 0.842981L8.46409 2.78094C8.44807 3.04521 8.22385 3.25342 7.95157 3.25342Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.42826 5.86422C3.29212 6.09645 3.00383 6.18454 2.76359 6.07243L0.993798 5.2556C0.81762 5.16751 0.745547 4.95129 0.841644 4.78312L1.194 4.1665C1.2901 3.99032 1.52233 3.94227 1.68249 4.0624L3.27611 5.18353C3.50033 5.33568 3.5644 5.63198 3.42826 5.86422Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.42788 11.0847C3.56402 11.317 3.49995 11.6133 3.27573 11.7654L1.68212 12.8866C1.52195 12.9987 1.29773 12.9506 1.19362 12.7824L0.841265 12.1738C0.745168 12.0057 0.809234 11.7814 0.99342 11.6933L2.76321 10.8765C3.00345 10.7644 3.29174 10.8525 3.42788 11.0847Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.95333 13.6953C8.22561 13.6953 8.44182 13.9035 8.47386 14.1678L8.65004 16.1057C8.66605 16.306 8.5139 16.4741 8.31369 16.4741H7.60898C7.40878 16.4741 7.25663 16.306 7.27264 16.1057L7.44882 14.1678C7.45683 13.9035 7.68105 13.6953 7.95333 13.6953Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4773 11.0847C12.6135 10.8525 12.9018 10.7644 13.142 10.8765L14.9118 11.6933C15.088 11.7814 15.1601 11.9977 15.064 12.1658L14.7116 12.7824C14.6155 12.9506 14.3833 13.0067 14.2231 12.8866L12.6295 11.7654C12.4053 11.6133 12.3412 11.317 12.4773 11.0847Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4773 5.86447C12.3412 5.63224 12.4053 5.33594 12.6295 5.18379L14.2231 4.06265C14.3833 3.95054 14.6155 3.99859 14.7116 4.16676L15.064 4.77537C15.1601 4.95155 15.096 5.16777 14.9118 5.24785L13.142 6.07269C12.9018 6.1848 12.6135 6.09671 12.4773 5.86447Z"
      fill="#FFC34A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.35722 4.01357C5.25312 4.07764 5.11698 4.0376 5.05291 3.9415L4.48434 3.03659C4.40426 2.90846 4.4443 2.73228 4.58043 2.6602C4.71657 2.58012 4.88474 2.63618 4.95682 2.76431L5.45332 3.70926C5.50137 3.82138 5.46933 3.94951 5.35722 4.01357Z"
      fill="#FFE332"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.78619 8.51466C2.78619 8.63478 2.69009 8.73889 2.56997 8.73889L1.50489 8.77893C1.35274 8.78693 1.22461 8.66681 1.22461 8.50665C1.22461 8.3545 1.35274 8.23438 1.50489 8.23438L2.56997 8.27442C2.69009 8.29043 2.78619 8.39454 2.78619 8.51466Z"
      fill="#FFE332"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.39843 12.9998C5.50254 13.0638 5.54258 13.192 5.48652 13.3041L4.99002 14.241C4.91794 14.3772 4.74978 14.4252 4.61364 14.3531C4.4775 14.2731 4.43746 14.1049 4.51754 13.9768L5.08611 13.0719C5.15819 12.9677 5.29433 12.9357 5.39843 12.9998Z"
      fill="#FFE332"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5865 12.9765C10.6906 12.9124 10.8267 12.9524 10.8908 13.0485L11.4593 13.9534C11.5394 14.0816 11.4994 14.2578 11.3633 14.3298C11.2271 14.4099 11.0589 14.3538 10.9869 14.2177L10.4904 13.2728C10.4423 13.1686 10.4744 13.0405 10.5865 12.9765Z"
      fill="#FFE332"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1582 8.47558C13.1582 8.35546 13.2543 8.25136 13.3744 8.25136L14.4395 8.21132C14.5917 8.20331 14.7198 8.32343 14.7198 8.48359C14.7198 8.63575 14.5917 8.75587 14.4395 8.75587L13.3744 8.71583C13.2543 8.69981 13.1582 8.5957 13.1582 8.47558Z"
      fill="#FFE332"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5471 3.98988C10.443 3.92582 10.4029 3.79769 10.459 3.68558L10.9555 2.74062C11.0276 2.60448 11.1957 2.55643 11.3319 2.63652C11.468 2.7166 11.508 2.88477 11.428 3.0129L10.8594 3.91781C10.7873 4.02192 10.6512 4.05395 10.5471 3.98988Z"
      fill="#FFE332"
    />
  </svg>
)

export default ClearIcon
